import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/user/_layout/crm")({
  beforeLoad: () => requireFeature("crm"),
  component: Outlet,
});
